import { useI18n } from 'vue-i18n'
import { useLocale as useVuetifyLocale } from 'vuetify/framework'
import { useDayJs } from 'composables/dateTime.ts'
import { setLocale as setLocaleVeeValidate } from '@vee-validate/i18n'
import { useLocaleStore } from '@/stores/system'

export function useLocaleManager() {
	const { locale: localeI18n } = useI18n()
	const vuetifyLocale = useVuetifyLocale()
	const { dayjs } = useDayJs()
	const localeStore = useLocaleStore()
	function setLocale(local: string) {
		localeI18n.value = local
		vuetifyLocale.current.value = local
		setLocaleVeeValidate(local)
		dayjs.locale(local)
		localeStore.locale = local
	}

	return {
		setLocale,
	}
}
